<nav class="custom-navbar">
    <div class="d-flex flex-row justify-content-between align-items-center px-2 py-2 w-100 h-100 gap-sm-1">
        <div class="d-flex align-items-center h-100 gap-2 gap-sm-2 gap-lg-5">
            <button class="bg-transparent rounded-2 border-0 h-100" (click)="router.navigate(['dashboard','inicio'])">
                <img style="max-height: 100%; width: auto;" [src]="logoUrl" alt="Logo" />
            </button>

            @if (client_environment.features.hasClients && userCanSeeClientes && client_environment.appName !==
            'gruesnadal') {
            <div class="d-flex align-items-center">
                <button (click)="showClientDialog = true" class="btn btn-client cursor-pointer border-0 overflow-hidden"
                    [ngStyle]="{'max-width': navigationService.isMobileOrTablet() ? '7rem' : ''}"
                    style="outline: none; background-color: #f5f5f5; color: var(--color_primary)">
                    <i class="pi pi-user"></i>
                    <span *ngIf="clients.selected">
                        {{ (clients.selected.razon_social || clients.selected.nombre) + ' ' +
                        (clients.selected.apellido_1 ? (clients.selected.apellido_1 + ' ' + clients.selected.apellido_2)
                        : '' )}}
                    </span>
                </button>
            </div>
            }
        </div>

        <h1 *ngIf="!navigationService.isMobile()" class="text-white fs-4 badge">
            {{ dashboardService.headerTitle ?? 'Locatec' | titlecase }}
        </h1>

        <div class="d-flex gap-sm-2 gap-lg-5 gap-4 align-items-center">
            @if(client_environment.appName === 'agrogestSIEX') {
            <p-menu #helpMenu [model]="helpMenuItems" [popup]="true" appendTo="body"></p-menu>
            <p-button ngClass="btn-help-navbar" [label]="!navigationService.isMobileOrTablet() ? 'Ayuda' : ''"
                [ngStyle]="{ 'background-color': '#db4061 !important;'}"
                icon="pi pi-question-circle"
                (onClick)="helpMenu.toggle($event)">
            </p-button>
            }

            <div class="d-flex align-items-center gap-2">
                <span *ngIf="!navigationService.isMobileOrTablet()" class="text-lg text-white">{{currentUser.nombre}}
                    {{currentUser.apellidos}}</span>
                <div class="d-flex justify-content-center">
                    <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

                    <button *ngIf="!navigationService.isMobile()"
                        class="btn-menu d-flex justify-center align-items-center align-content-center"
                        (click)="menu.toggle($event)">
                        <i style="font-size: 1.5rem;" class="pi pi-bars"></i>
                    </button>

                    <button *ngIf="navigationService.isMobile()"
                        class="btn-menu d-flex justify-center align-items-center align-content-center"
                        (click)="toogleSidebar()">
                        <i *ngIf="!navigationService.sidebarCollapsed()" style="font-size: 1.5rem;"
                            class="pi pi-bars"></i>
                        <i *ngIf="navigationService.sidebarCollapsed()" style="font-size: 1.5rem;"
                            class="pi pi-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</nav>

@if (client_environment.features.hasClients && userCanSeeClientes && client_environment.appName !== 'gruesnadal') {
<p-dialog [header]="'Seleccionar ' + client_environment.features.clientesName" [style]="{width: '40vw' ,height: '60vh'}"
    [(visible)]="showClientDialog" [breakpoints]="{'1199px': '75vw', '575px': '90vw'}" (onShow)="scrollToTop()">

    <label>Seleccionar {{ client_environment.features.clientesName }}</label>

    <p-select [options]="clients.filtered" [(ngModel)]="clients.selected"
        [placeholder]="'Seleccionar ' + client_environment.features.clientesName" optionValue="value"
        optionLabel="label" [filter]="true" [showClear]="true" (onChange)="updateClient()">
    </p-select>

    <div class="w-100 d-flex justify-content-center">
        <button class="btn btn-primary" style="margin-top: 2rem" (click)="showClientDialog = false">Aceptar</button>
    </div>
</p-dialog>
}


<p-dialog #clientProfileDialog header="Mi perfil" [closable]="false" [modal]="true" [breakpoints]="{'1199px': '75vw', '575px': '90vw'}"
    [visible]="showModalProfile()">

    @if(!isComunero) {
    <div class="container-fluid">
        <div class="d-flex justify-content-between">
            <p> {{currentUser.email || 'Usuario sin email'}} </p>
            @if (client_environment.appName !== 'agrogestSIEX') {
                <div class="d-flex justify-content-center">
                    <p-button severity="info" label="Firma" icon="pi pi-pencil" iconPos="left"
                        (click)="showSignature()"></p-button>
                </div>
            }
        </div>

        <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2" [fields]="formFields"
            (formChanges)="formChanges($event)">
        </app-form-builder>

        <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2" [fields]="formFields2"
            (formChanges)="formChanges($event)">
        </app-form-builder>

        <hr>

        @if (client_environment.appName !== 'agrogestSIEX') {
            <div  class="d-flex flex-column justify-content-center">
                <div class="d-flex flex-row justify-content-between align-items-center mb-2">
                    <p class="lead">Firma</p>
                    <button data-html2canvas-ignore="true" class="p-0 m-0 btn btn-link btn-link-tight"
                        (click)="modelSignature.set('')">Borrar</button>
                </div>
                <div class="d-flex justify-content-center align-items-center border rounded-2">
                    <app-signature *ngIf="!modelSignature()" #sp (signature)="drawComplete($event)"></app-signature>
        
                    <img [class.w-100]="navigationService.isMobile()" *ngIf="modelSignature()" [src]="modelSignature()" alt="" class="w-50">
                </div>
            </div>
        }
    </div>
    }

    @else {
    <div class="w-100">
        <p>{{ (currentClient.email | titlecase) ?? 'Usuario sin email' }}</p>
        <hr>
        <app-form-builder [model]="currentClient" [undoEnabled]="false" [distributionColumns]="2" [fields]="formClient"
            (formChanges)="formChanges($event)">
        </app-form-builder>
    </div>
    }

    <ng-template #footer>
        <div class="w-100 d-flex flex-column justify-content-center align-content-center gap-2">
            <div class="d-flex justify-content-center gap-2">
                <button class="btn btn-dark" (click)="showClientProfile.set(false)">Volver</button>
                <button *ngIf="!actualizando()" class="btn btn-primary" (click)="saveProfileEdit()">
                    <i class="fa fa-pencil" aria-hidden="true"></i> Actualizar
                </button>
                
                <button *ngIf="actualizando()" class="btn btn-primary" disabled>
                    <div class="spinner-border spinner-border-sm" role="status"></div> Actualizando...
                </button>
            </div>

            <p class="mt-5" [ngStyle]="this.subscriptionType === 'demo' ? 
                {color: 'red', textAlign: 'center'} : 
                {color: 'black', textAlign: 'center'}
                ">{{client_environment.appName === 'agrogestSIEX' ? subscriptionStatusMessage : '8 MB de 1 GB usados.'}}
            </p>

            @if (client_environment.appName === 'agrogestSIEX' && subscriptionType === 'demo') {
                <button pButton class="p-button-primary" label="Suscribirse" (click)="openDocumentInNewTab()"></button>
            }
        </div>
    </ng-template>
</p-dialog>

<app-wizard-modal [(visible)]="displayWizard"></app-wizard-modal>